// src/pages/Login.jsx
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Login.css";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Existing logic (DO NOT REMOVE)
  const fromInviteParam =
    new URLSearchParams(location.search).get("fromInvite") === "true";

  // NEW redirect param (main method)
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get("redirect"); // e.g., "/requests"

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await login(mobile, password);

      // 1️⃣ New official redirect logic
      if (redirectTo) {
        navigate(redirectTo, { replace: true });
        return;
      }

      // 2️⃣ Backward compatibility for old invite flow
      if (fromInviteParam) {
        navigate("/requests", { replace: true });
        return;
      }

      // 3️⃣ Normal login
      navigate("/", { replace: true });

    } catch (err) {
      alert("Invalid mobile number or password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-page-bg">
      <div className="login-card">

        <h2 className="login-title">Cashify</h2>
        <p className="login-subtitle">Login to continue</p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Mobile Number</label>
            <input
              type="tel"
              className="form-control login-input"
              maxLength="10"
              pattern="[0-9]{10}"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter 10-digit mobile"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button type="submit" className="btn login-btn w-100">
            {submitting ? "Logging in..." : "Login"}
          </button>
        </form>

        <p className="login-bottom-fg">
          <Link to="/forgot-password">Forgot Password?</Link>
        </p>

        <p className="login-bottom">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </p>

      </div>
    </div>
  );
};

export default Login;
